import * as React from 'react';
import { Divider, Paper, Box, Card, CardContent, CardMedia, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

import TopicMark from "@imgs/icon-campaign.png";

const kClr_m1 = "#FA9A29";
const kClr_m2 = "#DEEEC0";
const kClr_m3 = "#FFF3E6";

export default function SoroeruCard() {
  return (
    <Box component="section" id="point" sx={{ mt: 2, pb: 0 }}>
      <Box component="div" className="container">
        <Paper sx={{
          px: { xs: 1, sm: 3 }, py: { xs: 1, sm: 3 },
          bgcolor: kClr_m3,
          border: 3, borderColor: kClr_m1, borderRadius: 4
        }}
        >
          <Card >
            {/*
            <CardMedia
              image={bgImage}
              title="green iguana"
              sx={{ height: 140, borderRadius: 3, }}
            />
            */}
            <CardContent sx={{ px: 2, py: 2 }}>
              <Grid xs={12} sm={12} sx={{ mt: 1, ml: { xs: 1, sm: 2 }, fontSize: '18px', fontWeight: 600 }}>
                <Box component="img" src={TopicMark}
                  sx={{ width: '40px', height: '40px', mb: '-10px', mr: '5px', border: 0, borderRadius: '2px' }}
                />
                ご挨拶
              </Grid>
              <Divider sx={{ mb: 3 }} />

              <Typography variant="body2" color="text.secondary" sx={{ px: 2 }}>
                社員代表社長の許です。<br /><br />
                情報技術に頼り、金融市場で小さな規模で生き残り、成長することができました。情報技術をさらに多くの領域に活用し、情報技術を通じて顧客に価値を提供し、信頼を得るべきだと認識していることで、会社を作りました。
                <br /><br />
                より広範な社会で共存し、共に発展したいです。常に時代の流れをいち早く捉え、新たな技術を融合・蓄積することで、お客様のご要望を実現可能なソリューションに変換し、付加価値の高いサービスを提供し続けます。
                <br /><br />
                お客様から信頼されるパートナーとなるために、お客様企業の業務効率化、経営課題の解決、イノベーションの実現に積極的に貢献してまいります。
                <br /><br />
                今後とも変わらぬご支援を賜りますよう、よろしくお願い申し上げます。
              </Typography>
            </CardContent>
          </Card>
        </Paper>
      </Box>
    </Box>
  );
}
